import { BANKER, PLAYER, TIE } from './utils';

export const GAME_RINGS = ['one', 'two', 'three', 'four'];
export const GAME_OUTCOMES = [TIE, BANKER, PLAYER];
